import { render, staticRenderFns } from "./siteDetail.vue?vue&type=template&id=82ab89f8&scoped=true"
import script from "./siteDetail.vue?vue&type=script&lang=js"
export * from "./siteDetail.vue?vue&type=script&lang=js"
import style0 from "./siteDetail.vue?vue&type=style&index=0&id=82ab89f8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ab89f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82ab89f8')) {
      api.createRecord('82ab89f8', component.options)
    } else {
      api.reload('82ab89f8', component.options)
    }
    module.hot.accept("./siteDetail.vue?vue&type=template&id=82ab89f8&scoped=true", function () {
      api.rerender('82ab89f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plan/rightPopup/stockPage/directPurchaseSpecialPrice/directSendChild/siteDetail.vue"
export default component.exports